import { render, staticRenderFns } from "./SetMarksModal.vue?vue&type=template&id=72511e4c&scoped=true&"
import script from "./SetMarksModal.vue?vue&type=script&lang=js&"
export * from "./SetMarksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72511e4c",
  null
  
)

export default component.exports